export enum OrderSourceValues {
  NATIVE = 'native',
  KIOSK = 'kiosk',
  GENERIC_MARKETPLACE = 'marketplace',
  UBER_EATS_MARKETPLACE = 'ue_marketplace',
  DOORDASH_MARKETPLACE = 'dd_marketplace',
  GRUBHUB_MARKETPLACE = 'gh_marketplace',
  SHAREBITE_MARKETPLACE = 'sb_marketplace',
  MEALPAL_MARKETPLACE = 'mp_marketplace',
  FOODA_MARKETPLACE = 'fa_marketplace',
}
